import { render, staticRenderFns } from "./EmployeeSummaryMessage.vue?vue&type=template&id=174d0d34&scoped=true&lang=pug"
import script from "./EmployeeSummaryMessage.vue?vue&type=script&lang=ts"
export * from "./EmployeeSummaryMessage.vue?vue&type=script&lang=ts"
import style0 from "./EmployeeSummaryMessage.vue?vue&type=style&index=0&id=174d0d34&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174d0d34",
  null
  
)

/* custom blocks */
import block0 from "./EmployeeSummaryMessage.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Frunner%2Fwork%2Fcompliance-nationbetter-uk%2Fcompliance-nationbetter-uk%2Fsrc%2Fmodules%2FEmployees%2FTemplate%2Fviews%2FSummary%2Fcomponents%2FEmployeeSummaryMessage.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports